// ============================================
// Backward Compatibility Layer
// Re-exports from modular jobApi structure
// ============================================

export * from "./jobApi";
